"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AppContext = void 0;
Object.defineProperty(exports, "changeDate", {
  enumerable: true,
  get: function get() {
    return _utils.changeDate;
  }
});
Object.defineProperty(exports, "clsDebounce", {
  enumerable: true,
  get: function get() {
    return _utils.clsDebounce;
  }
});
Object.defineProperty(exports, "clsNames", {
  enumerable: true,
  get: function get() {
    return _utils.clsNames;
  }
});
Object.defineProperty(exports, "dConfirm", {
  enumerable: true,
  get: function get() {
    return _Dialog.dConfirm;
  }
});
Object.defineProperty(exports, "dError", {
  enumerable: true,
  get: function get() {
    return _Dialog.dError;
  }
});
Object.defineProperty(exports, "dSuccess", {
  enumerable: true,
  get: function get() {
    return _Dialog.dSuccess;
  }
});
Object.defineProperty(exports, "date", {
  enumerable: true,
  get: function get() {
    return _utils.date;
  }
});
Object.defineProperty(exports, "dbdate", {
  enumerable: true,
  get: function get() {
    return _utils.dbdate;
  }
});
Object.defineProperty(exports, "debounce", {
  enumerable: true,
  get: function get() {
    return _useDebounce.useDebouncedCallback;
  }
});
Object.defineProperty(exports, "fromNow", {
  enumerable: true,
  get: function get() {
    return _utils.fromNow;
  }
});
Object.defineProperty(exports, "get", {
  enumerable: true,
  get: function get() {
    return _connect.get;
  }
});
Object.defineProperty(exports, "isDev", {
  enumerable: true,
  get: function get() {
    return _connect.isDev;
  }
});
Object.defineProperty(exports, "isEmpty", {
  enumerable: true,
  get: function get() {
    return _utils.isEmpty;
  }
});
Object.defineProperty(exports, "linkClick", {
  enumerable: true,
  get: function get() {
    return _connect.linkClick;
  }
});
exports.loadMeta = loadMeta;
Object.defineProperty(exports, "num", {
  enumerable: true,
  get: function get() {
    return _utils.num;
  }
});
Object.defineProperty(exports, "post", {
  enumerable: true,
  get: function get() {
    return _connect.post;
  }
});
Object.defineProperty(exports, "qsget", {
  enumerable: true,
  get: function get() {
    return _utils.qsget;
  }
});
Object.defineProperty(exports, "qsset", {
  enumerable: true,
  get: function get() {
    return _utils.qsset;
  }
});
Object.defineProperty(exports, "rand", {
  enumerable: true,
  get: function get() {
    return _utils.rand;
  }
});
Object.defineProperty(exports, "round", {
  enumerable: true,
  get: function get() {
    return _utils.round;
  }
});
Object.defineProperty(exports, "sameDate", {
  enumerable: true,
  get: function get() {
    return _utils.sameDate;
  }
});
Object.defineProperty(exports, "subscribe", {
  enumerable: true,
  get: function get() {
    return _connect.subscribe;
  }
});
Object.defineProperty(exports, "symb", {
  enumerable: true,
  get: function get() {
    return _utils.symb;
  }
});
Object.defineProperty(exports, "tError", {
  enumerable: true,
  get: function get() {
    return _Dialog.tError;
  }
});
Object.defineProperty(exports, "tInfo", {
  enumerable: true,
  get: function get() {
    return _Dialog.tInfo;
  }
});
Object.defineProperty(exports, "tSuccess", {
  enumerable: true,
  get: function get() {
    return _Dialog.tSuccess;
  }
});
Object.defineProperty(exports, "test", {
  enumerable: true,
  get: function get() {
    return _utils.test;
  }
});
Object.defineProperty(exports, "todate", {
  enumerable: true,
  get: function get() {
    return _utils.todate;
  }
});
Object.defineProperty(exports, "trim", {
  enumerable: true,
  get: function get() {
    return _utils.trim;
  }
});
exports.useAppContext = void 0;
exports.useAppStateContext = useAppStateContext;
exports.version = exports.useUser = exports.useMeta = exports.useData = void 0;
var _useDebounce = require("use-debounce");
var _connect = require("./connect");
var _utils = require("./utils");
var _Dialog = require("./Dialog");
var _react = require("react");
var _excluded = ["ok", "__time"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
var version;
exports.version = version;
try {
  exports.version = version = require('./package.json').version;
} catch (e) {
  exports.version = version = 'dev';
}
var AppContext = /*#__PURE__*/(0, _react.createContext)({
  user: null,
  meta: {},
  data: {}
});
exports.AppContext = AppContext;
function useAppStateContext() {
  var _useState = (0, _react.useState)({}),
    _useState2 = _slicedToArray(_useState, 2),
    data = _useState2[0],
    setData = _useState2[1];
  var _useState3 = (0, _react.useState)({}),
    _useState4 = _slicedToArray(_useState3, 2),
    meta = _useState4[0],
    setMeta = _useState4[1];
  var _useState5 = (0, _react.useState)(null),
    _useState6 = _slicedToArray(_useState5, 2),
    user = _useState6[0],
    setUser = _useState6[1];
  return {
    data: data,
    setData: setData,
    meta: meta,
    setMeta: setMeta,
    user: user,
    setUser: setUser
  };
}
var useAppContext = function useAppContext() {
  return (0, _react.useContext)(AppContext);
};
exports.useAppContext = useAppContext;
var useMeta = function useMeta() {
  return (0, _react.useContext)(AppContext).meta;
};
exports.useMeta = useMeta;
var useData = function useData() {
  return (0, _react.useContext)(AppContext).data;
};
exports.useData = useData;
var useUser = function useUser() {
  return (0, _react.useContext)(AppContext).user;
};
exports.useUser = useUser;
function loadMeta(_need, context) {
  (0, _connect.get)('app/meta', {
    _need: _need
  }).then(function (_ref) {
    var ok = _ref.ok,
      __time = _ref.__time,
      data = _objectWithoutProperties(_ref, _excluded);
    if (ok) context.setMeta(function (prev) {
      return _objectSpread(_objectSpread({}, prev), data);
    });
  });
}

// ----